exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.edit-profile-modal{font-size:16px\n}\n.edit-profile-modal .base-editable-field,.edit-profile-modal .non-base-editable-field,.edit-profile-modal .static-field{font-size:16px;margin-left:0\n}\n.nav-profile a{height:56px;width:56px\n}\n.password-loading.v-btn .v-btn__content{min-width:130px\n}", ""]);

// exports
